import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg
    width="15"
    height="14"
    viewBox="0 0 15 14"
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M6.33333 3.5H3.41667C2.77233 3.5 2.25 4.02233 2.25 4.66667V9.91667C2.25 10.561 2.77233 11.0833 3.41667 11.0833H11.5833C12.2277 11.0833 12.75 10.561 12.75 9.91667V4.66667C12.75 4.02233 12.2277 3.5 11.5833 3.5H8.66667M6.33333 3.5V2.91667C6.33333 2.27233 6.85567 1.75 7.5 1.75C8.14433 1.75 8.66667 2.27233 8.66667 2.91667V3.5M6.33333 3.5C6.33333 4.14433 6.85567 4.66667 7.5 4.66667C8.14433 4.66667 8.66667 4.14433 8.66667 3.5M5.75 8.16667C6.39433 8.16667 6.91667 7.64433 6.91667 7C6.91667 6.35567 6.39433 5.83333 5.75 5.83333C5.10567 5.83333 4.58333 6.35567 4.58333 7C4.58333 7.64433 5.10567 8.16667 5.75 8.16667ZM5.75 8.16667C6.51196 8.16667 7.16015 8.65364 7.40039 9.33333M5.75 8.16667C4.98804 8.16667 4.33979 8.65364 4.09955 9.33333M9.25 6.41667H11M9.25 8.75H10.4167" />
  </svg>
);
